<template>
  <div class="page-wrapper">
    <section class="integral-banner">
      <img src="@/assets/images/national-day/banner.jpg" alt="" class="banner-img">
    </section>
    <section class="integral-introduce">
      <img src="@/assets/images/national-day/img1.jpg" alt="" class="introduce-img">
    </section>
    <section class="integral-task" id="downloadButton">
      <ul class="task-box">
        <li
          v-for="(item, index) in clickName"
          :key="index"
          class="task-item"
        >
          <span class="task-btn"></span>
        </li>
      </ul>
    </section>
    <section class="integral-rule">
      <img src="@/assets/images/national-day/img3.jpg" alt="" class="rule-img">
    </section>
    <van-overlay :show="show">
      <div class="overlay-wrapper" @click.stop>
        <div class="overlay-text">{{ text }}</div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Toast } from 'vant'
import getTimeIsEnd from '@/api/national-day'

export default {
  name: 'index',
  data() {
    return {
      show: false,
      text: '',
      clickName: ['activity://go-signin', 'activity://go-lottery', 'activity://go-post', 'activity://go-zxcar', 'activity://go-bindcar', 'activity://go-register']
    }
  },
  created() {
    getTimeIsEnd()
    .then((res) => {
      const result = res.data
      this.text = result.message
      // resultCode 508-活动未开始 200-活动进行中 507-活动已结束
      if (result.resultCode === 507) {
        this.show = true
      } else {
        this.show = false
        const { appType } = this.$route.query
        const key = Number(appType) === 0 ? 'xjpkzs' : 'ou6un5' // 用户端0  车队端1
        this.getScript()
          .then(() => {
            // eslint-disable-next-line no-undef
            // const data = OpenInstall.parseUrlParams()/// openinstall.js中提供的工具函数，解析url中的所有查询参数
            const { host, protocol } = window.location
            const pathname = '/jac-direct-mall-activity-h5/national-day/index'
            const data = {
              activeStates: 1,
              info: {
                url: `${protocol}//${host}${pathname}`
              }
            }
            // eslint-disable-next-line no-undef,no-new
            new OpenInstall({
              /* appKey必选参数，openinstall平台为每个应用分配的ID */
              appKey: key,
              /* OpenInstall初始化完成的回调函数，可选 */
              onready() {
                /* 在app已安装的情况尝试拉起app */
                this.schemeWakeup()
                /* 用户点击某个按钮时(假定按钮id为downloadButton)，安装app */
                const m = this; const button = document.getElementById('downloadButton')
                button.onclick = function () {
                  m.wakeupOrInstall()
                  return false
                }
              }
            }, data)
          })
      }
    })
    .catch((err) => {
      Toast(err.message || '请求失败')
    })
  },
  methods: {
    getScript() {
      return new Promise((resolve) => {
        const $script = document.createElement('script')
        global.document.body.appendChild($script)
        $script.src = 'https://web.cdn.openinstall.io/openinstall.js'
        $script.onload = () => {
          resolve()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.integral-banner {
  height: rem(743);
  .banner-img {
    width: 100%;
    height: 100%;
  }
}
.integral-introduce {
  height: rem(383);
  .introduce-img {
    width: 100%;
    height: 100%;
  }
}
.integral-task {
  width: 100%;
  height: rem(931);
  background: url('../../assets/images/national-day/img2.jpg') no-repeat;
  background-size: contain;
  overflow: hidden;
  .task-box {
    margin: rem(122) rem(52);
    .task-item {
      display: flex;
      justify-content: flex-end;
      width: rem(644);
      height: rem(122);
      background-size: contain;
      background-repeat: no-repeat;
      margin-bottom: rem(10);
      &:nth-child(1) {
        background-image: url('../../assets/images/national-day/item1.png');
      }
      &:nth-child(2) {
        background-image: url('../../assets/images/national-day/item2.png');
      }
      &:nth-child(3) {
        background-image: url('../../assets/images/national-day/item3.png');
      }
      &:nth-child(4) {
        background-image: url('../../assets/images/national-day/item4.png');
      }
      &:nth-child(5) {
        background-image: url('../../assets/images/national-day/item5.png');
      }
      &:nth-child(6) {
        background-image: url('../../assets/images/national-day/item6.png');
      }
      .task-btn {
        width: rem(116);
        height: 100%;
        border-radius: rem(18);
      }
    }
  }
}
.integral-rule {
  height: rem(495);
  .rule-img {
    width: 100%;
    height: 100%;
  }
}
.overlay-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .overlay-text {
    color: #fff;
    font-size: rem(32);
    font-weight: 700;
  }
}
</style>
